var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{style:({ height: _vm.descriptionHeight }),attrs:{"id":"cssEditorDescription"}}),_c('div',{style:({ height: ("calc(100% - " + _vm.descriptionHeight + ")") }),attrs:{"id":"cssEditor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }